/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ProductIdentityShort = {
    id: string;
    type: ProductIdentityShort.type;
    value: string;
};

export namespace ProductIdentityShort {

    export enum type {
        SKU = 'SKU',
        NAME = 'NAME',
        AI = 'AI',
    }


}

